import { useMemo, useState, useEffect } from 'react';
import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';
import MojitoCore from 'mojito/core';

const { useLocalizedParams } = MojitoPresentation.Hooks;
const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;
const AnalyticsContextBuilder = MojitoCore.Presentation.AnalyticsContext.ContextBuilder;
const EventsCoupon = MojitoModules.EventsCoupon;
const analyticsMatchesPath = 'Matches';

export default function MatchesCoupon({ mojitoTools, eventGroupsId, isInPlayCoupon }) {
    const { config, emitPerformanceMark } = mojitoTools;
    const { sportId, filter } = useLocalizedParams();
    const matchesContext = useMemo(
        () =>
            new AnalyticsContextBuilder()
                .withAnalyticsPath(`${analyticsMatchesPath}_${filter}`)
                .build(),
        [filter]
    );

    // Determining child modules loading state
    const [loadedEventGroupId, setLoadedEventGroupId] = useState();

    useEffect(() => {
        const isDataLoad = eventGroupsId && eventGroupsId === loadedEventGroupId;
        emitPerformanceMark('moduleRendered', isDataLoad);
    }, [emitPerformanceMark, loadedEventGroupId, eventGroupsId]);

    const onDataLoad = eventGroupId => {
        setLoadedEventGroupId(eventGroupId);
    };

    return eventGroupsId ? (
        <AnalyticsContextExtender value={matchesContext}>
            <EventsCoupon
                isInPlay={isInPlayCoupon}
                sportId={sportId}
                eventGroupsId={eventGroupsId}
                config={config.eventsCoupon}
                onDataLoad={onDataLoad}
                enableSorting={true}
            />
        </AnalyticsContextExtender>
    ) : null;
}
